<script>
import { BCol, BRow } from 'bootstrap-vue'
import { StatisticsApi } from '@core/api'
import Overlay from '@core/components/common/Overlay.vue'
import SubstanceProductCountTableCard from '@/views/statistics/components/SubstanceProductCountTableCard.vue'
import SentProductRequestOverview from '@/views/statistics/components/SentProductRequestOverview.vue'
import SupplierCommunicationOverview from '@/views/statistics/components/SupplierCommunicationOverview.vue'

export default {
    components: {
        SupplierCommunicationOverview,
        SentProductRequestOverview,
        SubstanceProductCountTableCard,
        Overlay,
        BRow,
        BCol,
    },
    props: {
        productId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            showLoading: true,
            metrics: {},
        }
    },
    created() {
        StatisticsApi.getProductStats(this.productId).then(response => {
            this.metrics = response.data
            this.showLoading = false
        })
    },
}
</script>

<template>
    <Overlay :show="showLoading">
        <b-row>
            <b-col>
                <SentProductRequestOverview
                    :total="metrics['counter.product.requests.sent.total'] || {data: 0}"
                    :new="metrics['counter.product.requests.sent.new'] || {data: 0}"
                    :replied="metrics['counter.product.requests.sent.replied'] || {data: 0}"
                    :approved="metrics['counter.product.requests.sent.approved'] || {data: 0}"
                />
            </b-col>
            <b-col>
                <SupplierCommunicationOverview
                    :contacted="metrics['counter.product.suppliers.contacted'] || {data: 0}"
                    :logged-in="metrics['counter.product.suppliers.logged_in'] || {data: 0}"
                    :opened-product-request="metrics['counter.product.suppliers.opened_product_request'] || {data: 0}"
                    :replied-product-request="metrics['counter.product.suppliers.replied_product_request'] || {data: 0}"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SubstanceProductCountTableCard
                    :metric="metrics['aggregate.product.component.substance.count'] || {data: []}"
                    :product-id="productId"
                />
            </b-col>
        </b-row>
    </Overlay>
</template>
